
const state = {
  currentVariantId: null
}

const mutations = {
  SELECT_VARIANT (state, variantId) {
    state.currentVariantId = variantId
  }
}

const actions = {
  selectVariant ({ commit }, variantId) {
    commit('SELECT_VARIANT', variantId)
  }
}

export default { namespaced: true, state, mutations, actions }